import { useQuery } from 'react-query';

import { queryKeys } from 'src/services/api/constants';
import { apiClient } from 'src/services/api/client';
import type { IIntegrationWithOwnerName } from 'src/services/api/integrations/types';
import type { IIntegration } from 'src/services/api/integrations/types';

const PATH = 'api/landlord/facebook-integration';

type Response = {
    user_integration: IIntegration
    team_integrations: IIntegrationWithOwnerName[]
}

export const useFacebookIntegration = (options?: { disabled?: boolean}) => {
    return useQuery(
        [queryKeys.facebookIntegration],
        async () => {
            const response = await apiClient(PATH).json<Response>();
            return response;
        },
        { enabled: !options?.disabled }
    );
};
